import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import {objectToQueryParams} from "@/utils/publicFun";
import ListView from "@/components/AntListView";
import { get } from "mobx";

/**
 * @description 兑换
 * @return {/culturalExchange_maotaisecond/exchangepage}
 */

const ExchangePage = (props) => {
  const navigate = useNavigate();
  const [collectionList, setCollectionList] = useState([]); // 藏品列表数据
  const [selectedItems, setSelectedItems] = useState([]); // 已选择的藏品
  // const maxSelectCount = 18; // 最多兑换9个春，也就最多选择18个
  const [nftNoList,setNftNoList] = useState([]);//兑换藏品的nftno
  const [collList,setCollList] = useState([]);//成功展示的 collectionName 藏品名称  nftNo 藏品编号  nftImage 藏品相对路径  nftImageUrl 藏品绝对路径
  const [flag,setFlag] = useState(false);//是否有未领权益：true是，false否
  const [useNum,setUseNum] = useState(0);//消耗数量
  const [num,setNum] = useState(0);//可得数量
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);
  const [collRedeemNum,setCollRedeemNum] = useState(0);//当前最多可兑换多少个春

  useEffect(() => {
    // 初始化数据 - 模拟数据，实际应该从接口获取
    (()=>{
      getData();
    })()
  }, []);

  const getData = async () => {
    const resdata = await Service.getRecData();
    if (resdata.code !== '000000') throw resdata.msg;
    // setRecData(resdata.data);
    setCollectionList(resdata.data?.list || []);
    setCollRedeemNum(resdata.data?.collRedeemNum || 0);
  }

  const handleBack = () => {
    navigate(-1);
  }

  // 选择/取消选择藏品
  const handleSelectItem = async(item) => {
    const isSelected = selectedItems.some(selected => selected.nftNo === item.nftNo);
    
    if (isSelected) {
      // 取消选择
      const list = selectedItems.filter(selected => selected.nftNo !== item.nftNo);
      setSelectedItems(list);
      const selectedNftNos = list.map(item => item.nftNo);
      const res = await Service.checkRecData(selectedNftNos);
      if (res.code === '000000'){
        setFlag(!!res.data?.flag);//是否有未领权益：true是，false否
      };
    } else {
      // 选择
      if (selectedItems.length < collRedeemNum*2) {
        const list = [...selectedItems, item];
        setSelectedItems(list);
        const selectedNftNos = list.map(item => item.nftNo);
        const res = await Service.checkRecData(selectedNftNos);
        if (res.code === '000000'){
          setFlag(!!res.data?.flag);//是否有未领权益：true是，false否
        };
      } else {
        Toast.show(`最多只能选择${collRedeemNum*2}个藏品`);
      }
    }
  }

  // 点击合成按钮
  const handleCompound = async() => {
    if (selectedItems.length === 0) {
      Toast.show('请至少选择一个藏品');
      return;
    }
    
    // if (selectedItems.length < 2) {
    //   Toast.show(`需再选${2 - selectedItems.length}个藏品方可兑换`);
    //   return;
    // }
    const selectedNftNos = selectedItems.map(item => item.nftNo);
    setNftNoList(selectedNftNos);

    try {
      showLoading();
      const res = await Service.checkRecData(selectedNftNos);
      if (res.code !== '000000'){
        Toast.show(res.msg);
        return;
      };
      const data = res.data || {};
      setFlag(!!data.flag);//是否有未领权益：true是，false否
      setUseNum(data.useNum || 0);//消耗数量
      setNum(data.num || 0);//可得数量
      setConfirmVisible(true);
    } catch (error) {
      Toast.show(error?.msg || '校验失败, 请稍后重试');
    } finally {
      hideLoading();
    }
  }
  const handleExchange = async() => {
    if (!nftNoList.length) {
      Toast.show('请先选择要兑换的藏品');
      return false;
    }

    try {
      showLoading();
      const res = await Service.recColl(nftNoList);
      if (res.code !== '000000'){
        Toast.show(res.msg);
        return false;
      };
      const list = (res.data && res.data.list) || [];
      setCollList(list);
      setSuccessVisible(true);
      getData();
      Toast.show('兑换成功');
      return true;
    } catch (error) {
      Toast.show(error?.msg || '兑换失败, 请稍后重试');
      return false;
    } finally {
      hideLoading();
    }
  }
  const handleConfirmExchange = async () => {
    const success = await handleExchange();
    if (success) {
      setConfirmVisible(false);
      setSelectedItems([]);
      setNftNoList([]);
    }
  }
  const handleViewCollection = () => {
    setSuccessVisible(false);
    let url = `/myCollection?code=21`
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.replace("CustomWeb", { uri: `${window.location.origin}${url}` });
    } else {
      navigate(url, { replace: true });
    }
  }
  const toExchangeRecord = () => {
    const uri = `/culturalExchange_maotaisecond/exchangeRecord`
    if(uri){
      navigate(uri);
    }
  }


  return (
    <div className={Styles.collectionRecord}>
      {/* 状态栏 */}
      <div className={Styles.statusBar}>
      </div>

      {/* 导航栏 */}
      <div className={Styles.navBar}>
        <div className={Styles.backButton} onClick={handleBack}>
        </div>
        <div className={Styles.title}>兑换</div>
        <div className={Styles.placeholder} onClick={toExchangeRecord}>兑换记录</div>
      </div>

      {/* 内容区域 */}
      <div className={Styles.contentArea}>
        <div className={Styles.titleArea}>
          <div className={Styles.titleText}>请选择回收藏品</div>
          <div className={Styles.countText}>当前持有 {collectionList?.length || 0} 个</div>
        </div>

        {/* 藏品列表瀑布流 */}
        {collectionList.length >0 && <div className={Styles.collectionGrid}>
          {collectionList.map((item) => {
            const isSelected = selectedItems.some(selected => selected.nftNo === item.nftNo);
            const isMaxSelected = selectedItems.length >= collRedeemNum*2;
            const isDisabled = !isSelected && isMaxSelected;

            return (
              <div 
                key={item.id} 
                className={`${Styles.collectionItem} ${isDisabled ? Styles.disabled : ''}`}
                onClick={() => handleSelectItem(item)}
              >
                {/* 选择状态图标 */}
                {isSelected && (
                  <div className={Styles.selectedIcon}>
                    <img src={require('@/assets/img/culturalExchange_maotaisecond/selected.png')} alt="已选择" />
                  </div>
                )}
                
                {/* 禁用遮罩层 */}
                {isDisabled && (
                  <div className={Styles.disabledOverlay}></div>
                )}

                {/* 藏品图片 */}
                <div className={`${Styles.collectionImage} ${isSelected ? Styles.selected : ''}`}>
                  <img src={item.nftImage} alt={item.nftNo} />
                </div>

                {/* 藏品编号 */}
                <div className={Styles.collectionName}>#{item.nftNo}</div>
              </div>
            );
          })}
        </div>}
        {collectionList.length === 0 && (
          <div className={Styles.noData}>
            <div className={Styles.noDataText}>当前无兑换材料<br />请购买盲盒</div>
          </div>
        )}

        {/* 底部提示信息和合成按钮 */}
        <div className={Styles.bottomArea}>
          <div className={Styles.hintText}>
            {flag && <p>藏品有权益未领取,确认兑换即视为放弃权益</p>}
            <p className={Styles.wc}>当前最多可兑换{collRedeemNum}个"春"数字资产</p>
          </div>
          
          <div className={Styles.compoundBtn} onClick={handleCompound}>
            <img src={require('@/assets/img/culturalExchange_maotaisecond/compound_btn.png')} alt="合成" />
          </div>
        </div>
      </div>
      <NFTModal
        visible={confirmVisible}
        closeOnMaskClick={false}
        showCloseButton={false}
        onClose={() => setConfirmVisible(false)}
        content={
          <div className={Styles.exchangeModal}>
            <div className={Styles.modalTitle}>兑换</div>
            {flag && (
              <p className={Styles.warningText}>
                藏品有权益未领取
                <br />
                确认兑换即视为放弃权益
              </p>
            )}
            <div className={Styles.modalContent}>
              <p>兑换可得<span className={Styles.highlight}>{num}</span>个“春”数字资产</p>
              <p>确认将<span className={Styles.highlight}>{useNum}</span>个藏品兑换吗？</p>
              <p>合成后藏品将被销毁</p>
            </div>
            <div className={Styles.modalActions}>
              <div className={`${Styles.actionBtn} ${Styles.cancelBtn}`} onClick={() => setConfirmVisible(false)}>取消</div>
              <div className={`${Styles.actionBtn} ${Styles.confirmBtn}`} onClick={handleConfirmExchange}>确认兑换</div>
            </div>
          </div>
        }
      />
      <NFTModal
        visible={successVisible}
        closeOnMaskClick={false}
        showCloseButton={false}
        onClose={() => setSuccessVisible(false)}
        content={
          <div className={Styles.successModal}>
            <div className={Styles.modalTitle}>兑换成功</div>
            <div className={Styles.successPreview}>
              {collList[0]?.nftImageUrl ? (
                <img src={collList[0].nftImageUrl} alt={collList[0].collectionName || '兑换藏品'} />
              ) : (
                <div className={Styles.imagePlaceholder}></div>
              )}
            </div>
            <div className={Styles.successCount}>x{collList.length}</div>
            <div className={Styles.modalActions}>
              <div className={`${Styles.actionBtn} ${Styles.cancelBtn}`} onClick={() => setSuccessVisible(false)}>取消</div>
              <div className={`${Styles.actionBtn} ${Styles.confirmBtn}`} onClick={handleViewCollection}>查看藏品</div>
            </div>
          </div>
        }
      />
    </div>
  )
}

export default ExchangePage
